import type { NotesData } from '../stateMappers/caseRunToCodingScreenState';

/**
 * Defensive guard shared by `NoteNav`/`NoteViewer`: a bound slot value that isn't the expected
 * shape (unset, wrong type, or from before `cmxDocumentContents` existed) degrades to an empty
 * state rather than throwing and taking the pane down with it.
 */
export function asNotesData(value: unknown): NotesData {
  if (
    value == null ||
    typeof value !== 'object' ||
    !Array.isArray((value as NotesData).notes)
  ) {
    return { notes: [], cmxDocumentContents: [] };
  }
  const data = value as NotesData;
  const cmxDocumentContents = data.cmxDocumentContents ?? [];
  const covered = new Set(
    cmxDocumentContents.flatMap((entry) =>
      (entry.renditions ?? []).map((rendition) => rendition.documentId)
    )
  );
  return {
    notes: data.notes.filter((note) => !covered.has(note.document_id)),
    cmxDocumentContents
  };
}
